import { assertNever } from "~/tools/assert-never";
import {
	millisecondsToMinutes,
	millisecondsToSeconds,
	minutesToMilliseconds,
	secondsToMilliseconds,
} from "~/tools/date-time";
import { fps } from "~/tools/fps";
import type { Record } from "~/tools/record";

export type UseNowFloor = "milliseconds" | "seconds" | "minutes";

export const MINIMAL_FLOOR_INTERVAL = {
	milliseconds: fps(60),
	seconds: fps(10),
	minutes: fps(1),
} satisfies Record<UseNowFloor>;

export function floorMilliseconds(ms: number, floor: UseNowFloor): number {
	// biome-ignore lint/nursery/noUnnecessaryConditions: false positive https://github.com/biomejs/biome/issues/8332
	switch (floor) {
		case "milliseconds": {
			return ms;
		}

		case "seconds": {
			return secondsToMilliseconds(millisecondsToSeconds(ms));
		}

		case "minutes": {
			return minutesToMilliseconds(millisecondsToMinutes(ms));
		}

		default: {
			return assertNever(floor);
		}
	}
}
